import { ScrollText } from "lucide-react";
import type { StrainGraph } from "@/types";
import { useStore } from "@/store/useStore";
import { CommentThread } from "@/components/CommentThread";

// strain-level comments view (not anchored to a specific node).
// in canvas mode, comments are anchored; this is for the strain-wide thread.

export function CommentsView({ graph }: { graph: StrainGraph }) {
  // show strain-level (unanchored) comments + a composer
  return (
    <div className="h-full overflow-y-auto bg-grid-fine">
      <div className="max-w-2xl mx-auto px-4 py-6">
        <div className="mb-4 flex items-center gap-2">
          <ScrollText size={16} className="text-[var(--color-ink-muted)]" />
          <div>
            <h2 className="text-lg font-semibold">Strain discussion</h2>
            <p className="text-[12px] text-[var(--color-ink-muted)]">
              Strain-level comments. For precise points, anchor to a node or edge in the canvas.
            </p>
          </div>
        </div>
        <CommentThread strainId={graph.strain.id} />
      </div>
    </div>
  );
}
